import { useEffect, useState } from 'react'
import { FullBillFragment, useDeleteBillMutation } from '../../../graphql/generated/graphql'

export const useRemoveBill = (bill: FullBillFragment | null) => {
    const [removed, setRemoved] = useState<boolean>(false)

    useEffect(() => {
        setRemoved(false)
    }, [bill])

    const [removeBill, { loading }] = useDeleteBillMutation({
        variables: { accountId: bill?.accountId ?? '', provider: bill?.provider },
        onCompleted(data) {
            setRemoved(data?.deleteBill)
        },
        update: (cache) => {
            cache.modify({
                id: cache.identify(bill!),
                fields: {
                    connected() {
                        return false
                    },
                },
            })
        },
    })

    return { removeBill, loading, removed }
}
